import { CompassProTestApi } from '@/../generated-client/apis/CompassProTestApi';
import { useApiStore } from '@/stores/apiStore';
import { fetchData } from './BaseDAO';

let compassProTestApi: CompassProTestApi | null = null;
let lastConfig: unknown = null;

function getCompassProTestApi(): CompassProTestApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (compassProTestApi === null || lastConfig !== apiConfig) {
    compassProTestApi = new CompassProTestApi(apiConfig);
    lastConfig = apiConfig;
  }

  return compassProTestApi;
}
export const getTestByMatrixCode = async (matrixCode: string) => {
  const api = getCompassProTestApi();

  return await api.apiCompassProTestGetTestByMatrixCodeGet({ matrixCode });
};

export const getGraphDataByDateAndType = async (
  date: string,
  type: string,
  bearerToken: string,
) => {
  return await fetchData(
    `CompassProTest/GetGraphDataByDateAndType?date=${date}&test_name=${type}`,
    bearerToken,
  );
};

export const getMonthlySumByDate = async (date: string) => {
  const api = getCompassProTestApi();
  return await api.apiCompassProTestGetMonthlySumByDateGet({ date });
};

export const getManufacturingMetrics = async (
  startTimestamp: Date,
  endTimestamp: Date,
  bearerToken: string,
) => {
  return await fetchData(
    `CompassProTest/ManufacturingMetrics?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`,
    bearerToken,
  );
};

export const exportManufacturingResults = async (
  startTimestamp: Date,
  endTimestamp: Date,
  bearerToken: string,
) => {
  return await fetchData(
    `CompassProTest/ExportResults?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`,
    bearerToken,
  );
};
